import MockCard from './MockCard';
import { Typography } from '@navi/web-ui/lib/primitives';
import { useSelector } from 'react-redux';
import { RootState } from '@cp/src/store';
import { LoadingIcon } from '@navi/web-ui/lib/icons';

const MockRunsList = () => {
  const mockRunsListMap = useSelector((state: RootState) => state.fieldAllocation?.mockRunsMap);
  const mockRunsList = Object.values(mockRunsListMap || {});

  const mockRunsListLoading = useSelector(
    (state: RootState) => state.fieldAllocation?.mockRunsListLoading
  );

  if (mockRunsListLoading) {
    return (
      <div className="flex justify-center items-center h-full">
        <LoadingIcon />
      </div>
    );
  }

  if (mockRunsList?.length === 0) {
    return (
      <div className="flex flex-col justify-center items-center h-full">
        <Typography variant="h5" className="mt-6" color="var(--light-grayscale-content-2)">
          All mock runs will be visible here
        </Typography>
      </div>
    );
  }

  return (
    <>
      {mockRunsList.map((mockRun, index) => (
        <MockCard
          key={mockRun.allocationTrackerId}
          mockRun={mockRun}
          mockNumber={mockRunsList.length - index}
        />
      ))}
    </>
  );
};

export default MockRunsList;
